import React from "react";
import { months } from "../../../../../../Utils/months";
import { RowNames } from "../../../Utils/TableComponents";
import SolidosMonth from "./SolidosMonth";

export default function SolidosTable() {
    const rowNames = [
        'Entradas MP a producción',
        '(+) Gtos. De compra de MP',
        '(+) Gtos. Fabricación del mes',
        '(=) Producción del mes',
        '(+) Prod. Term. Mes anterior',
        '(=) Prod. Term. Disponible',
        '(-) Costo Vta. Del Mes',
        '(=) Prod. Termin. Final',
    ];

    return (
        <div className="report__table-container report__solidos-table-container">
            <h6>SÓLIDOS</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[3, 5, 7]} />
                {months.map((month, index) => {
                    return (<SolidosMonth key={index} month={month} monthIndex={index} />)
                })}
            </div>
        </div>
    );
}
